import React, { Component, PropTypes } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import LeftComponent from "components/Authorization/LeftComponent";
import SignUpForm from "components/Authorization/SignUp/SignUpForm";
import actions from "actions";
import constants from "constants";
import validator from "services/validator.js";
import moment from "moment";
import { registerRequestToAdmin } from "../../../actions/users";

const { createUser, cleanErrors, addValidateError } = actions;

const { ERROR_TYPE_USER_CREATE_ERROR } = constants;

const mapUser = ({ first_name, last_name, email, company, reason, role }) => ({
  first_name,
  last_name,
  email,
  company,
  reason,
  role,
});

const otherUserFields = [
  "first_name",
  "last_name",
  "email",
  "company",
  "reason",
  "role",
];

class SignUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        first_name: "",
        last_name: "",
        email: "",
        password: "",
        email_confirmation: "",
        user_type: null,
        registration: "",
        imc: "",
        time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        ipna_member: false,
        branch: "",
        country: "",
        company: "",
        reason: "",
        role: "",
        company_name: "",
        position: "",
        accreditation: true,
      },
      termsOfService: false,
      isIndustry: false,
    };
  }

  componentWillMount() {
    this.props.cleanErrors();
  }

  validateUser = () => {
    this.props.validateUser(validator.validate(this.state.user, "user"));
  };

  onFieldChange = (e) => {
    const userData = {
      ...this.state.user,
      ...{
        [e.target.name]: e.target.value,
      },
    };

    this.setState({ user: userData }); //, this.validateUser); on input change validation
  };

  onTermsOfServiceChange = (status) => {
    this.setState({
      termsOfService: status,
    });
  };

  onIpnaChange = (event) => {
    const userData = {
      ...this.state.user,
      ...{
        ipna_member: event.target.value == "true",
      },
    };

    this.setState({ user: userData });
  };

  onAccreditaionChange = (event) => {
    const userData = {
      ...this.state.user,
      ...{
        accreditation: event.target.value == "true",
      },
    };
    this.setState({ user: userData });
  };
  // onPinNumberChange = (event) => {
  //   const userData = {
  //     ...this.state.user,
  //     ...{
  //       pin_number: event.target.value == 'true'
  //     }
  //   }
  //   this.setState({ user: userData })
  //
  // }

  onBranchChange = (status) => {
    const userData = {
      ...this.state.user,
      ...{
        branch: status.value,
      },
    };

    this.setState({ user: userData });
  };

  onCountryChange = (status) => {
    const userData = {
      ...this.state.user,
      ...{
        country: status.value,
      },
    };

    this.setState({ user: userData });
  };

  onIndustryChange = (e) => {
    const isIndustry = e.target.checked;
    this.setState({
      isIndustry,
      user: {
        ...this.state.user,
        user_type: isIndustry ? "industry" : null,
        ...(isIndustry
          ? {}
          : { company_name: "", position: "" }),
      },
    });
  };

  onCreateSubmit = (e) => {
    e.preventDefault();

    if (this.state.isIndustry) {
      if (!(this.state.user.company_name || "").trim()) {
        toast.warning("Company name is required");
        return;
      }
      if (!(this.state.user.position || "").trim()) {
        toast.warning("Position/role in the company is required");
        return;
      }
      if (!this.state.termsOfService) {
        toast.warning("Terms of service must be accepted");
        return;
      }
      this.props.createUser(
        this.state.user,
        this.props.location.query.redirectBack,
      );
      return;
    }

    if (
      this.state.user.user_type === "other" &&
      otherUserFields
        .map((key) => {
          if (!this.state.user[key]) {
            return true;
          }
        })
        .some((v) => v)
    ) {
      toast.warning("All fields are required");
      return;
    }

    if (this.state.user.user_type === "other") {
      this.props.registerRequestToAdmin({ user: mapUser(this.state.user) });
      return;
    }

    if (!this.state.termsOfService) {
      toast.warning("Terms of service must be accepted");
      return;
    }
    if (
      this.state.user.ipna_member === true &&
      this.state.user.branch.length == 0
    ) {
      toast.warning("Branch required.");
      return;
    }
    if (
      this.state.user.accreditation === false &&
      !this.state.user.registration &&
      !this.state.user.user_type === "pharmacist"
    ) {
      console.log("accreditation number required");
      toast.warning("Accreditation number required.");
      return;
    }
    if (this.state.user.accreditation === false && !this.state.user.country) {
      toast.warning("Country required.");
      return;
    }

    if (
      this.state.user.accreditation === true &&
      (this.state.user.user_type === "nurse_specialist" ||
        this.state.user.user_type === "allied_healthcare_professional") &&
      !this.state.user.registration
    ) {
      toast.warning("Accreditation number required.");
      return;
    }

    // if (
    //   !this.state.user.pin_number &&
    //   (this.state.user.user_type === "nurse" && this.state.user.nurse_type === 'general_practice_nurse')
    // ) {
    //   toast.warning("NMBI PIN Number required.");
    //   return;
    // }

    if (
      this.state.user.accreditation === true &&
      (this.state.user.user_type === "gp" ||
        this.state.user.user_type === "gp_trainee" ||
        this.state.user.user_type === "consultant" ||
        this.state.user.user_type === "hospital_doctor") &&
      !this.state.user.imc
    ) {
      toast.warning("IMC number required.");
    }

    if (
      !this.state.user.registration_number &&
      this.state.user.user_type === "pharmacist"
    ) {
      toast.warning("Registration Number required.");
      return;
    }

    this.props.createUser(
      this.state.user,
      this.props.location.query.redirectBack,
    );
  };

  irishRoleFields = () => {
    switch (this.state.user.user_type) {
      case "gp":
        return ["imc"];
      case "gp_trainee":
        return ["imc"];
      case "consultant":
        return ["imc"];
      case "hospital_doctor":
        return ["imc"];
      case "nurse_specialist":
        return ["registration"];
      // case "nurse":
      //   return this.state.user.nurse_type === 'general_practice_nurse' ? ["pin_number"] : [];
      case "allied_healthcare_professional":
        return ["profession", "registration"];
      case "pharmacist":
        return ["registration_number"];
      case "industry":
        return ["company_name", "position"];
      default:
        return [];
    }
  };

  internationRoleFields = () => {
    switch (this.state.user.user_type) {
      case "gp":
        return ["registration"];
      case "gp_trainee":
        return ["registration"];
      case "consultant":
        return ["registration"];
      case "hospital_doctor":
        return ["registration"];
      case "nurse_specialist":
        return ["registration"];
      // case "nurse":
      //   return this.state.user.nurse_type === 'nurse_specialist' ? ["registration"] : [];
      case "allied_healthcare_professional":
        return ["profession", "registration"];
      case "pharmacist":
        return ["registration_number"];
      case "industry":
        return ["company_name", "position"];
      default:
        return [];
    }
  };

  render() {
    const { errors, errorsFrontend } = this.props;

    const outErrors = Object.keys(errorsFrontend || {}).length
      ? errorsFrontend
      : errors;
    return (
      <main className="">
        <div className="container_content_password">
          <LeftComponent />
          <SignUpForm
            user={this.state.user}
            onFieldChange={this.onFieldChange}
            onSubmit={this.onCreateSubmit}
            errors={outErrors}
            onTermsOfServiceChange={this.onTermsOfServiceChange}
            termsOfService={this.state.termsOfService}
            irishRoleFields={this.irishRoleFields()}
            internationRoleFields={this.internationRoleFields()}
            onIpnaChange={this.onIpnaChange}
            onBranchChange={this.onBranchChange}
            onCountryChange={this.onCountryChange}
            onAccreditaionChange={this.onAccreditaionChange}
            redirectBack={this.props.location.query.redirectBack}
            isIndustry={this.state.isIndustry}
            onIndustryChange={this.onIndustryChange}
            // onPinNumberChange={this.onPinNumberChange}
          />
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  errors: state["errors"][ERROR_TYPE_USER_CREATE_ERROR],
  errorsFrontend: state["errors"][`${ERROR_TYPE_USER_CREATE_ERROR}_FRONTEND`],
});

const mapDispatchToProps = (dispatch) => ({
  validateUser: (errors) =>
    dispatch(addValidateError(ERROR_TYPE_USER_CREATE_ERROR, errors)),
  createUser: (user, redirect) => dispatch(createUser(user, redirect)),
  registerRequestToAdmin: (payload) =>
    dispatch(registerRequestToAdmin(payload)),
  cleanErrors: () => dispatch(cleanErrors(ERROR_TYPE_USER_CREATE_ERROR)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SignUp);



// WEBPACK FOOTER //
// ./src/containers/Authorization/SignUp/SignUp.js